import React, { useEffect, useState } from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import SupplierPortalDashboard from '../../pages/supplier/SupplierPortalDashboard';
import SupplierQuestionnaires from '../../pages/supplier/SupplierQuestionnaires';
import SupplierArticles from '../../pages/supplier/SupplierArticles';
import LoadingSpinner from '../ui/LoadingSpinner';

const ProtectedSupplierRoute: React.FC = () => {
  const { masterToken } = useParams<{ masterToken: string }>();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  // **DETERMINE WHICH COMPONENT TO RENDER BASED ON PATH**
  const getComponentForPath = () => {
    const path = location.pathname;
    console.log('🧭 Determining component for path:', path);
    
    if (path.includes('/questionnaires')) {
      console.log('📋 Rendering SupplierQuestionnaires');
      return <SupplierQuestionnaires />;
    } else if (path.includes('/articles')) {
      console.log('📦 Rendering SupplierArticles');
      return <SupplierArticles />;
    } else if (path.includes('/dashboard') || path.endsWith(masterToken || '')) {
      console.log('🏠 Rendering SupplierPortalDashboard');
      return <SupplierPortalDashboard />;
    } else {
      console.log('🏠 Default: Rendering SupplierPortalDashboard');
      return <SupplierPortalDashboard />;
    }
  };

  useEffect(() => {
    checkSupplierAuthentication();
  }, [masterToken]);

  const checkSupplierAuthentication = async () => {
    try {
      // Prüfe Session Storage für bestehende Supplier-Session
      const sessionToken = sessionStorage.getItem('supplierPortalSession');
      const sessionTime = sessionStorage.getItem('supplierPortalSessionTime');
      
      if (!sessionToken || !sessionTime) {
        console.log('🔒 No supplier session found - redirecting to login');
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      // Prüfe ob Session noch gültig ist (z.B. 24 Stunden)
      const sessionAge = Date.now() - parseInt(sessionTime);
      const maxSessionAge = 24 * 60 * 60 * 1000; // 24 Stunden

      if (sessionAge > maxSessionAge) {
        console.log('🕐 Supplier session expired - redirecting to login');
        sessionStorage.removeItem('supplierPortalSession');
        sessionStorage.removeItem('supplierPortalSessionTime');
        sessionStorage.removeItem('supplierInfo');
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      // **KORRIGIERT: Session-Validierung mit Backend**
      console.log('🔍 Validating session with backend...');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/public/portal/${masterToken}/validate-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          sessionToken: sessionToken
        })
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Supplier session valid');
        setIsAuthenticated(true);
      } else {
        console.log('❌ Supplier session invalid - redirecting to login');
        sessionStorage.removeItem('supplierPortalSession');
        sessionStorage.removeItem('supplierPortalSessionTime');
        sessionStorage.removeItem('supplierInfo');
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Error checking supplier authentication:', error);
      // **BEI NETZWERKFEHLERN: Session als ungültig betrachten**
      sessionStorage.removeItem('supplierPortalSession');
      sessionStorage.removeItem('supplierPortalSessionTime');
      sessionStorage.removeItem('supplierInfo');
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner text="Authentifizierung wird geprüft..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/supplier/portal/${masterToken}/login`} replace />;
  }

  return getComponentForPath();
};

export default ProtectedSupplierRoute;